import React, { ChangeEvent, useEffect, useState } from 'react'

import { Box, GhostSelect, InputWrapper, Typo } from '../atoms'

export interface DropDownMenuProps<T> {
  'aria-labelledby'?: string
  currentValue?: T
  placeholder?: string
  values: T[]
  formatter: (v: T) => string
  onSelectCallback: (value: T) => void
}

export const DropDownMenu: <T>(
  props: DropDownMenuProps<T>,
) => React.ReactElement<DropDownMenuProps<T>> | null = ({
  'aria-labelledby': ariaLabelledBy,
  currentValue,
  placeholder,
  values,
  formatter,
  onSelectCallback,
}) => {
  const [value, setValue] = useState(currentValue)

  useEffect(() => {
    setValue(currentValue)
  }, [currentValue])

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    let index = event.target.selectedIndex
    if (placeholder) index--

    setValue(values[index])
    onSelectCallback(values[index])
  }

  const menuOptions = values.map((v, index) => (
    <option key={index}>{formatter(v)}</option>
  ))
  const selectPickerValue = value !== undefined ? formatter(value) : undefined

  return (
    <InputWrapper width={1}>
      <Box width={1}>
        <Typo fontFamily='input'>
          <GhostSelect
            aria-labelledby={ariaLabelledBy}
            required
            value={selectPickerValue}
            onChange={onChange}
            defaultValue={placeholder ? placeholder : selectPickerValue}
          >
            {placeholder && (
              <option value={placeholder} disabled hidden>
                {placeholder}
              </option>
            )}
            {menuOptions}
          </GhostSelect>
        </Typo>
      </Box>
    </InputWrapper>
  )
}
